<h2 mat-dialog-title>
  Manage dependants
  @if (employeeDisplayName().trim()) {
    <span>- {{ employeeDisplayName() }}</span>
  }
</h2>

<mat-dialog-content>
  <mat-card class="p-4">
    <div class="mb-3 flex items-center justify-between">
      <h3 class="text-xl font-semibold">Dependants</h3>

      <div class="flex items-center gap-2">
        <button mat-stroked-button type="button" (click)="refresh()" [disabled]="employeeStore.dependantsLoading()">
          Refresh
        </button>

        @if (canManage()) {
          <button mat-icon-button type="button" (click)="manageDependant({ action: 'create' })" [disabled]="employeeStore.dependantSaving()">
            <mat-icon>add</mat-icon>
          </button>
        }
      </div>
    </div>

    @if (employeeStore.dependantsLoading() && employeeStore.dependants().length === 0) {
      <div class="flex items-center gap-3 p-4">
        <mat-spinner diameter="24" />
        Loading dependants...
      </div>
    } @else if (employeeStore.dependants().length === 0) {
      <p class="p-4 text-sm">No dependants found for this employee.</p>
    } @else {
      <div class="overflow-x-auto">
        <table class="min-w-full text-left text-sm">
          <thead>
            <tr class="border-b">
              <th class="px-3 py-2 font-medium">Name</th>
              <th class="px-3 py-2 font-medium">Dependant type</th>
              <th class="px-3 py-2 font-medium">Title</th>
              <th class="px-3 py-2 font-medium">Date of birth</th>
              <th class="px-3 py-2 font-medium">Contact</th>
              <th class="px-3 py-2 font-medium">Email</th>
              <th class="px-3 py-2 font-medium">Is Active</th>
              <th class="px-3 py-2 font-medium">Authorisation</th>
              @if (canManage()) {
                <th class="px-3 py-2 font-medium text-right">Actions</th>
              }
            </tr>
          </thead>

          <tbody>
            @for (dependant of employeeStore.dependants(); track dependant.id) {
              <tr class="border-b align-top">
                <td class="px-3 py-3 font-medium">{{ dependant.firstName }} {{ dependant.surname }}</td>
                <td class="px-3 py-3">{{ getDependantTypeName(dependant.dependantTypeId) }}</td>
                <td class="px-3 py-3">{{ getTitleName(dependant.titleId) }}</td>
                <td class="px-3 py-3">{{ dependant.dateOfBirth ?? '-' }}</td>
                <td class="px-3 py-3">{{ dependant.contactNumber ?? '-' }}</td>
                <td class="px-3 py-3">{{ dependant.emailAddress ?? '-' }}</td>
                <td class="px-3 py-3">{{ dependant.isActive ? 'Yes' : 'No' }}</td>
                <td class="px-3 py-3">{{ dependant.authorisationStatus === 'NotAuthorised' ? 'Not authorised' : dependant.authorisationStatus }}</td>

                @if (canManage()) {
                  <td class="px-3 py-3">
                    <div class="flex justify-end gap-2">
                      <button
                        mat-icon-button
                        type="button"
                        (click)="manageDependant({ dependant, action: 'edit' })"
                        [disabled]="employeeStore.dependantSaving()"
                        matTooltip="Edit"
                        aria-label="Edit"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>

                      <button
                        mat-icon-button
                        type="button"
                        [disabled]="actionDependantId() === dependant.id"
                        (click)="manageDependant({ dependant, action: 'toggle' })"
                        [matTooltip]="dependant.isActive ? 'Deactivate' : 'Activate'"
                        [attr.aria-label]="dependant.isActive ? 'Deactivate' : 'Activate'"
                      >
                        <mat-icon>{{ dependant.isActive ? 'block' : 'check_circle' }}</mat-icon>
                      </button>
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
